import { dateNow } from 'utils/core/now';
import { getNewGuid } from 'utils/guid';

declare global {
  interface Window {
    pollingQueueId: string;
  }
}
export function getPollingQueueId(): string | undefined {
  return window.pollingQueueId;
}

export function getNewPollingQueueId(): string {
  const now = new Date(dateNow());
  const guid = getNewGuid();
  return `${now.getUTCFullYear()}-${
    now.getUTCMonth() + 1
  }-${now.getUTCDate()}-${now.getUTCHours()}-${now.getUTCMinutes()}_${guid}`;
}
